import { Root as SeparatorRoot } from "@radix-ui/react-separator";
import { cn } from "@watt/ui/utils/classname-tailwind-merge";
import type * as React from "react";

interface SeparatorProps
  extends React.ComponentPropsWithoutRef<typeof SeparatorRoot> {
  ref?: React.Ref<React.ElementRef<typeof SeparatorRoot>>;
}

function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  ref,
  ...props
}: SeparatorProps) {
  return (
    <SeparatorRoot
      className={cn(
        "shrink-0 bg-border",
        orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        className
      )}
      decorative={decorative}
      orientation={orientation}
      ref={ref}
      {...props}
    />
  );
}
Separator.displayName = SeparatorRoot.displayName;

export { Separator };
